import React, { useState, useEffect, useRef } from 'react';
import './Navigation.css';

export type Page = 'home' | 'map' | 'info' | 'booking' | 'about' | 'gallery' | 'manage' | 'terms';

interface NavigationProps {
  currentPage: Page;
  onPageChange: (page: Page) => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentPage, onPageChange }) => {
  // All pages start with transparent navigation (scrolled = false)
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef<HTMLElement | null>(null);

  // Reset scrolled state when page changes
  useEffect(() => {
    setScrolled(false);
    // Reset scroll position to top when page changes
    window.scrollTo(0, 0);
  }, [currentPage]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Show scrolled state after scrolling past 50px on all pages
      setScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    // Set initial state
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const el = navRef.current;
    if (!el) return;

    const updateNavHeight = () => {
      const height = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--nav-height', `${height}px`);
    };

    updateNavHeight();

    let ro: ResizeObserver | null = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(() => updateNavHeight());
      ro.observe(el);
    } else {
      window.addEventListener('resize', updateNavHeight);
    }

    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener('resize', updateNavHeight);
    };
  }, [currentPage]);

  // Apply scrolled class based on scroll position for all pages
  const navClassName = `main-navigation ${scrolled ? 'scrolled' : ''}`;

  return (
    <nav ref={navRef} className={navClassName}>
      <div className="nav-brand">
        <h1>Southern Comfort Camps</h1>
        <p className="nav-subtitle"> </p>
      </div>
      <div className="nav-links">
        <button
          className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
          onClick={() => onPageChange('home')}
        >
          Home
        </button>
        <button
          className={`nav-link ${currentPage === 'gallery' ? 'active' : ''}`}
          onClick={() => onPageChange('booking')}
        >
          Book Your Stay
        </button>
        <button
          className={`nav-link ${currentPage === 'map' ? 'active' : ''}`}
          onClick={() => onPageChange('map')}
        >
          Plan Your Trip
        </button>
        <button
          className={`nav-link ${currentPage === 'info' ? 'active' : ''}`}
          onClick={() => onPageChange('info')}
        >
          Abrolhos Info
        </button>
        <button
          className={`nav-link ${currentPage === 'about' ? 'active' : ''}`}
          onClick={() => onPageChange('about')}
        >
          About Us
        </button>
        <button
          className={`nav-link ${currentPage === 'terms' ? 'active' : ''}`}
          onClick={() => onPageChange('terms')}
        >
          Terms
        </button>
        {/* <button
          className={`nav-link ${currentPage === 'booking' ? 'active' : ''}`}
          onClick={() => onPageChange('booking')}
        >
          Book Your Stay
        </button> */}
      </div>
    </nav>
  );
};

export default Navigation;

